import { useEffect, useLayoutEffect, useState } from "react"

import { useAppDispatch, useColorScheme } from "app/hooks"
import { RundooWordmark } from "components/base/assets"
import { SupportMenu } from "components/composite/SupportMenu"

import { clearState } from "./authSlice"
import { Disclaimer } from "./Disclaimer"
import { SignInContent } from "./SignInContent"
import { SignInProvider } from "./SignInContext"

export function SignIn() {
  const dispatch = useAppDispatch()

  const [isStateCleared, setIsStateCleared] = useState(false)
  useLayoutEffect(() => {
    dispatch(clearState())
    setIsStateCleared(true)
  }, [dispatch])

  useEffect(() => {
    if (typeof window.Intercom !== "function") return
    window.Intercom("shutdown")
    if (!window.intercomSettings) return
    window.Intercom("boot", window.intercomSettings)
  }, [])

  const scheme = useColorScheme()

  // clearState wipes the api cache but not its query subscriptions; children
  // mount after it so their queries refetch
  if (!isStateCleared) return null

  return (
    <SignInProvider redirectPath="/pos/sales/new">
      <div className="bg-elevation-surface-container-default flex h-screen w-screen flex-col items-center justify-between overflow-y-auto">
        <div className="flex w-full justify-between p-8">
          <RundooWordmark
            color={scheme === "dark" ? "white" : "blue"}
            width={122}
            height={20}
          />
          <SupportMenu />
        </div>
        <SignInContent />
        <Disclaimer />
      </div>
    </SignInProvider>
  )
}
